<template>
  <div id="app" :class="{ locked: isLoading }">
    <NavLoggedIn v-if="isUserLoggedIn" />
    <NavBeforeLogin v-else />
    <div
      :class="[
        isUserLoggedIn ? 'loggedIn' : 'notLoggedIn',
        { locked: isLoading },
      ]"
    >
      <transition name="fade">
        <Loading v-if="isLoading" />
      </transition>
      <transition name="fade">
        <router-view />
      </transition>
    </div>
    <ErrorToast />
  </div>
</template>

<script>
import NavBeforeLogin from "@/components/NavBeforeLogin";
import NavLoggedIn from "@/components/NavLoggedIn";
import { mapGetters } from "vuex";
import ErrorToast from "@/components/ErrorToast";
import Loading from "@/components/Loading";
import User from "@/services/User";
import store from "@/store";

export default {
  name: "app",
  components: {
    NavBeforeLogin,
    NavLoggedIn,
    ErrorToast,
    Loading,
  },
  onIdle() {
    if (this.isUserLoggedIn) {
      store.commit("removeToken");
      alert("Idle terlalu lama akan logout secara otomatis");
      location.reload();
    }
  },
  onActive() {
    if (this.isUserLoggedIn) {
      User.refreshJWTToken(process.env.VUE_APP_URL, this.getRefreshToken);
    }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "isLoading", "getRefreshToken"]),
  },
};
</script>

<style>
@media only screen and (min-width: 768px) {
  .notLoggedIn,
  .loggedIn {
    min-height: 878px !important;
    margin-top: 10vh !important;
    margin-bottom: 0 !important;
  }
}

.notLoggedIn {
  min-height: 84vh;
  margin: 8vh 0;
}

.loggedIn {
  min-height: 92vh;
  margin-bottom: 8vh;
  margin-top: 0;
}

.locked {
  overflow: hidden;
}

.fade-enter-active {
  transition: opacity 0s;
}

.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
